import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase/config";
import { getDealershipByEmail } from "../data/dealerships";
import { pumaFamilySchema } from "../lib/leadFormSchemas";
import { LEAD_TYPES, submitLeadEmail } from "./leadEmail";

export const PUMA_FAMILY_COLLECTION = "puma-family-2026";

export async function submitPumaFamilyRequest(values, sourceUrl) {
  const data = pumaFamilySchema.parse(values);
  const dealershipLabel = getDealershipByEmail(data.dealership)?.label ?? "";
  const model = data.model;
  const request = await addDoc(collection(db, PUMA_FAMILY_COLLECTION), {
    ...data,
    dealershipLabel,
    campaignSlug: PUMA_FAMILY_COLLECTION,
    model,
    sourceUrl,
    date: serverTimestamp(),
  });

  // The inquiry is already saved; an email failure must not invite a duplicate submission.
  try {
    await submitLeadEmail({
      type: LEAD_TYPES.CAMPAIGN_OFFER,
      customer: { name: data.name, email: data.email, phone: data.phone },
      dealership: { email: data.dealership, label: dealershipLabel },
      vehicle: { model },
      campaign: { slug: PUMA_FAMILY_COLLECTION },
      source: { pageUrl: sourceUrl },
      title: `Запитване за оферта - Ford ${model} | Puma Family 2026`,
    });
  } catch (error) {
    console.error("Запитването е записано, но имейлът не беше изпратен:", error);
  }
  return request.id;
}
